import React, { useState, useEffect } from 'react';

const navItems = [
  { label: 'Platform',     href: '#platform'     },
  { label: 'Features',     href: '#features'     },
  { label: 'Integrations', href: '#integrations' },
  { label: 'Enterprise',   href: '#enterprise'   },
];

export default function Nav({ onDemo }) {
  const [scrolled,  setScrolled]  = useState(false);
  const [menuOpen,  setMenuOpen]  = useState(false);
  const [isMobile,  setIsMobile]  = useState(window.innerWidth <= 900);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    const onResize = () => {
      setIsMobile(window.innerWidth <= 900);
      if (window.innerWidth > 900) setMenuOpen(false);
    };
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '1rem 2.5rem',
        borderBottom: `1px solid ${scrolled ? 'rgba(10,158,143,0.2)' : 'rgba(10,158,143,0.13)'}`,
        background: 'rgba(6,6,6,0.97)',
        position: 'sticky', top: 0, zIndex: 200,
        backdropFilter: 'blur(12px)',
      }}>
        {/* Logo */}
        <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src="/dialspark-wordmark-dark.svg" alt="DialSpark" width="126" height="30" style={{ display: 'block', height: 30, width: 'auto' }} />
        </a>

        {/* Desktop links */}
        {!isMobile && (
          <ul style={{ display: 'flex', gap: '2rem', listStyle: 'none', margin: 0, padding: 0 }}>
            {navItems.map(item => (
              <li key={item.label}>
                <a href={item.href} style={{ color: '#909090', fontSize: '0.8125rem', cursor: 'pointer', transition: 'color .2s', fontWeight: 400, textDecoration: 'none' }}
                  onMouseEnter={e => e.target.style.color = '#f0f0f0'}
                  onMouseLeave={e => e.target.style.color = '#909090'}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        )}

        {/* Right side */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {/* Hamburger — mobile only */}
          {isMobile && (
            <button
              onClick={() => setMenuOpen(o => !o)}
              aria-label="Toggle menu"
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              {menuOpen
                ? <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f0f0f0" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                : <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#f0f0f0" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
              }
            </button>
          )}
        </div>
      </nav>

      {/* Mobile dropdown */}
      {isMobile && menuOpen && (
        <div style={{
          position: 'fixed',
          top: 57,
          left: 0,
          right: 0,
          background: '#060606',
          borderBottom: '1px solid rgba(10,158,143,0.18)',
          zIndex: 199,
          boxShadow: '0 16px 40px rgba(0,0,0,0.7)',
        }}>
          {navItems.map((item, i) => (
            <a
              key={item.label}
              href={item.href}
              onClick={closeMenu}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '1.1rem 1.75rem',
                fontSize: '0.9375rem',
                fontWeight: 500,
                fontFamily: "'Sora', sans-serif",
                color: '#c0c0c0',
                textDecoration: 'none',
                borderBottom: i < navItems.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none',
                transition: 'background .15s, color .15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = 'rgba(10,158,143,0.06)'; e.currentTarget.style.color = '#f0f0f0'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#c0c0c0'; }}
            >
              {item.label}
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0a9e8f" strokeWidth="2" strokeLinecap="round"><path d="M9 18l6-6-6-6"/></svg>
            </a>
          ))}
        </div>
      )}
    </>
  );
}
